import ActivatePatient from './ActivatePatient';

export default ActivatePatient;
